import React, { Component } from "react";
import "./Notification.scss";
import { Notifications } from "../../views/CaseControl/CaseControl";
class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false
    };
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({ mounted: true });
    }, 200);
  }
  render() {
    let { notificationOpen, closeNotification } = this.props;
    let { mounted } = this.state;
    return (
      <div
        className="notification-popup-overlay"
        style={{ opacity: mounted ? 1 : 0 }}
      >
        <div
          className="notification-popup"
          style={{
            marginTop: mounted ? 0 : -200,
            transform: mounted ? "scale(1)" : "scale(0.8)"
          }}
        >
          <div className="notification-head">
            <span>Notification</span>
            <i
              className="fa fa-close"
              onClick={() => {
                if (closeNotification) {
                  this.setState({ mounted: false });
                  setTimeout(() => {
                    closeNotification();
                  }, 200);
                }
              }}
            />
          </div>
          <div className="notification-list">
            <Notifications />
          </div>
        </div>
      </div>
    );
  }
}

export default Notification;
